<div class="row">
  <div class="col-12">
    <div class="logo-delcorp">
      <span [routerLink]="['']">
        <fa-icon [icon]="['fas', 'arrow-left']" class="arrow-atras" style="cursor: pointer;"></fa-icon>
      </span>
      <figure class="figure">
        <img class="figure-img" alt={{logo.alt}} src={{logo.url}} style="margin-top:15px;width: 200px;">
      </figure>
    </div>
  </div>
</div>

<div class="content">
  <form (ngSubmit)="onVerifyEmail()" [formGroup]="registroForm" class="form form-registro">

    <div class="col-lg-12 col-md-12 col-12 ">

      <div class="mb-3">
        <div class="input-group">
          <input type="email" [(ngModel)]="objDatosFB.email" class="form-control" placeholder="Correo *"
            formControlName="txtEmail">
          <div class="exclamation"
            *ngIf="fRegistro.txtEmail.invalid && (fRegistro.txtEmail.dirty || fRegistro.txtEmail.touched)">
            <fa-icon [icon]="['fas', 'exclamation-circle']" [size]="xs" tooltip="Campo requerido" placement="top"
              *ngIf="fRegistro.txtEmail.errors.required"></fa-icon>
          </div>
        </div>
      </div>

    </div>

    <div class="col-lg-12 col-md-12 col-12">

      <button id="btnRegistrarUsuario" type="submit" class="btn  btn-block uk-link-reset widget-large uk-text-center uk-flex uk-flex-center"
      [ngClass]=" registroForm.invalid  ? 'btn-secondary' : 'btn-primary'  "
      [disabled]="registroForm.invalid ||  btnRegistrarUsuarioDisabled" >
      <span [ngSwitch]="showBtnRegistrarUsuario">
        <span *ngSwitchCase="1">
          VERIFICAR EMAIL
        </span>
        <span *ngSwitchCase="2">
          <fa-icon [icon]="['fas', 'circle-notch']" [spin]="true"></fa-icon>
        </span>
        <span *ngSwitchCase="3">
          <fa-icon [icon]="['fas', 'check']"></fa-icon>
        </span>
        <span *ngSwitchCase="4">
          <fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon>
        </span>
      </span>
    </button>

    </div>

  </form>
</div>
<script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/4710847.js"></script>
